// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"637":"12d4cbeb","776":"157dc7eb"}[chunkId] + ".css";
};